<template>
  <div class="myBag-wrapper">
    <div class="myBag-top">
      <Title-b :title="$t('cldhqk')" />
    </div>
    <div class="game">
      <i-input v-model="search" @on-change="changeSech()" :placeholder="$t('qsrtddh')" style="width: 300px"></i-input>
      <div class="background" @click="BillCode()">
        <img src="../../../assets/images/sousuo.png" alt="" />
      </div>
    </div>
    <Tabs active-key="2" @on-click="changeTab" v-model="tabIndex">
      <!-- <Tab-pane :label="'全部(' + total.all + ')'" key="key1"></Tab-pane>
      <Tab-pane :label="'未入庫(' + total.afterAll + ')'" key="key2"></Tab-pane>
      <Tab-pane :label="'已入庫(' + total.nowAll + ')'" key="key3"></Tab-pane> -->
      <Tab-pane :label="$t('Mypackage.Warehousing')" key="2"></Tab-pane>
      <Tab-pane :label="$t('Mypackage.Notstorage')" key="3"></Tab-pane>
      <Tab-pane :label="$t('djy')" key="1"></Tab-pane>
    </Tabs>

    <!-- <i-table border :loading="loading" :columns="columns" :data="list" v-if="showTable" @on-selection-change="selectList" id="table">
      <template slot-scope="{ row }" slot="name">
        <div style="display:flex;line-height: 30px">
          <div style="width: 260px;">{{$t('Forecastpackage.couriernumber')}}：<span style="color: #999;font-weight:bold;">{{row.kdBillCode}}</span></div>
          <div style="width: 220px">{{$t('Forecastpackage.Size')}}(cm)：<span style="color: #515a6e">{{row.Size ? row.Size : 0*0*0}}</span></div>
        </div>
        <div style="display:flex;line-height: 30px">
          <div style="width: 260px">{{$t('Forecastpackage.ActualWeight')}}：<span style="color: #515a6e">{{ row.Weight }}（kg）</span></div>
          <div style="width: 220px">{{$t('Forecastpackage.VolumeWeight')}}：<span style="color: #515a6e">{{ row.Weight2 }}（kg）</span></div>
        </div>
        <div style="display:flex;line-height: 30px">
          <div style="width: 260px;">{{$t('Forecastpackage.goodsvale')}}：<span style="color: #515a6e">{{row.GoodsValue + "" ? row.GoodsValue : 0}}$</span></div>
        </div>
        <div style="display:flex;line-height: 30px">
          <div style="width: 260px;">{{$t('dksj')}}：<span style="color: #515a6e">{{ row.dd_time ? row.dd_time : "未到庫" }}</span></div>
        </div>
        <div style="display:flex;line-height: 30px">
          <div>
            {{$t('Forecastpackage.ShelfTime')}}：<span style="color: #515a6e" v-if="row.inplaceTime">{{ row.inplaceTime}}</span>
            <span style='color: #f00' v-else>{{$t('Forecastpackage.ShelfReminder')}}</span>
          </div>
        </div>
      </template>
    </i-table> -->
    <div style="height: 60vh;">
      <pageScroll ref="scroll" :columns="columns" :queryTableFunc="queryBillCode" @selectTable="selectList">
      </pageScroll>
    </div>
    <r-mask :title="$t('Mypackage.Editor')" :isShowModal="showModal" @closeMask="closeEdit">
      <i-form ref="formRef" :model="formInline" :rules="ruleInline" label-position="right" :label-width="100" inline>
        <Form-item :label="$t('Forecastpackage.couriernumber')" prop="kdBillcode">
          <Input v-model="formInline.kdBillcode" :disabled="true" style="width: 310px" />
        </Form-item>
        <Form-item :label="$t('Forecastpackage.Namegoods')">
          <!-- <Select v-model="GoosMoaol" filterable multiple style="width: 310px">
            <Option v-for="(item, idx) in goodsName" :key="idx" :value="item"
              >{{ item }}
            </Option>
          </Select> -->
          <Input v-model="formInline.Goods" :placeholder="$t('Forecastpackage.Pleasename')" style="width: 310px" />
        </Form-item>
        <Form-item :label="$t('Forecastpackage.Typeofgoods')" prop="Goodsid">
          <i-select v-model="formInline.Goodsid" :label-in-value="true" style="width: 310px"
            :placeholder="$t('Forecastpackage.Pleasegoods')" @on-change="changeSelect">
            <i-option :value="item.GoodsID" v-for="(item, index) in GoodList" :key="index">{{ item.GoodsName }}</i-option>
          </i-select>
        </Form-item>
        <Form-item :label="$t('Forecastpackage.Quantitygoods')">
          <Input v-model="formInline.Number" :placeholder="$t('Forecastpackage.Pleasequantitygoods')"
            style="width: 310px" />
        </Form-item>
        <Form-item :label="$t('Forecastpackage.goodsvale')">
          <Input v-model="formInline.GoodsValue" style="width: 310px" />
        </Form-item>
        <Form-item :label="$t('Forecastpackage.Remarks')">
          <Input v-model="formInline.Goods_meno" style="width: 310px" />
        </Form-item>
      </i-form>
      <div class="upBtn">
        <Button-b value="提交" @click.native="handleSubmit('formRef')" />
      </div>
    </r-mask>
    <r-mask title="批量修改" :isShowModal="setshowModal" @closeMask="setcloseEdit">
      <i-form ref="formset" :model="formInline" :rules="ruleInline" label-position="right" :label-width="100" inline>
        <Form-item :label="$t('Forecastpackage.Namegoods')">
          <Input v-model="formInlines.Goods" :placeholder="$t('Forecastpackage.Pleasename')" style="width: 310px" />
        </Form-item>
        <Form-item :label="$t('Forecastpackage.goodsvale')">
          <Input v-model="formInlines.GoodsValue" style="width: 310px" />
        </Form-item>
      </i-form>
      <div class="upBtn">
        <Button-b value="提交" @click.native="setbag()" />
      </div>
    </r-mask>
    <r-mask :title="$t('Mypackage.Applicationconsolidation')" :isShowModal="showApplay" @closeMask="close_btn">
      <div slot="price" class="price-title">
        {{ $t("Home.Weight") }}：{{ this.freeAdd.Free_Weight ? this.freeAdd.Free_Weight : 0 }}(kg) (cbm)
        {{ $t("Mypackage.Transportationcost") }}：
        <span class="price">
          {{ parseFloat(this.freeAdd.Free).toFixed(2) ? parseFloat(this.freeAdd.Free).toFixed(2) : 0 }}</span>
        RM({{ this.freeAdd.CountryMoneyUnit }}:{{ this.freeAdd.CountryMoney }})
      </div>
      <div>
        <div class="pirce-wrapper">
          <div>{{ $t("Mypackage.completed") }}</div>
        </div>
      </div>
      <i-table border stripe :columns="columnsBag" :data="sList"></i-table>
      <div class="info-form">
        <i-form ref="info" :model="info" :rules="ruleValidate2" :label-width="140">
          <Tabs active-key="2" @on-click="changeZt">
            <Tab-pane :label="$t('xzshdz')" key="2"></Tab-pane>
            <!-- <Tab-pane :label="$t('Personal.ChooseSelf')" key="3"></Tab-pane> -->
          </Tabs>
          <div class="info-flex" v-if="info.ServiceType == 3" style="position: relative; left: -36px">
            <Form-item label="收件人姓名：">
              <i-input placeholder="請輸入收件人姓名" v-model="info.Signer"></i-input>
            </Form-item>
            <Form-item label="收件人手機：" prop="mobile">
              <i-input placeholder="請輸入收件人手機" v-model="info.mobile"></i-input>
            </Form-item>
            <span style="font-size: 12px; position: absolute; width: 400px; right: 61px">(自提件,通過此手機號發送WHATS
              APP到貨通知,如無WHATSAPP請自行到網路查閱)</span>
          </div>
          <!-- 地址选择 -->
          <div class="select-flex" v-if="info.ServiceType == 3">
            <div class="select-style">
              <div class="label">目的地：</div>
              <i-select v-model="addressid.Country" @on-change="changeAddress($event, 'Country')" placeholder="請選擇">
                <i-option v-for="(item, index) in CountryList" :key="index" :value="item.CountryID">{{ item.CountryName
                }}</i-option>
              </i-select>
            </div>
            <div class="select-style">
              <div class="label">省份：</div>
              <i-select v-model="addressid.Provice" @on-change="changeAddress($event, 'Provice')" placeholder="請選擇">
                <i-option v-for="(item, index) in addList.Country" :key="index" :value="item.CodeID">{{ item.Name
                }}</i-option>
              </i-select>
            </div>
            <div class="select-style">
              <div class="label">直轄市：</div>
              <i-select v-model="addressid.City" @on-change="changeAddress($event, 'City')" placeholder="請選擇">
                <i-option v-for="(item, index) in addList.Provice" :key="index" :value="item.CodeID">{{ item.Name
                }}</i-option>
              </i-select>
            </div>
            <div class="select-style">
              <div class="label">縣轄區：</div>
              <i-select v-model="addressid.Area" @on-change="changeAddress($event, 'Area')" placeholder="請選擇">
                <i-option v-for="(item, index) in addList.City" :key="index" :value="item.CodeID">{{ item.Name
                }}</i-option>
              </i-select>
            </div>
          </div>
          <i-table
            border
            stripe
            :columns="addTable"
            :data="info.ServiceType == 2 ? addressList : ztList"
            style="margin-bottom: 20px;"
          ></i-table>


          <div class="info-flex" style="position: relative; left: -30px">
            <Form-item :label="$t('Mypackage.ShippingChannel')">
              <i-select v-model="info.AirTname" :label-in-value="true" @on-change="(v) => {
                  changeSelect3(v, 'AirTname');
                }
                " :placeholder="$t('Mypackage.Pleaseselectthetimelimit')" style="width: 162px">
                <i-option v-for="(item, index) in arrSx" :key="index" :value="item.id">{{ item.timeBarName }} {{ item.Rem }}
                  <span style="display: none">{{ "," + index }}</span>
                </i-option>
              </i-select>
              <p v-for="(item, index) in arrSx" :key="index" v-show="choseIndex == index">
                {{ item.Rem }}
              </p>
            </Form-item>
            <!-- <Form-item
              label="選擇承運商:"
              prop="cforhmType"
              style="position: absolute; left: 300px"
            >
              <i-select
                style="width: 162px"
                v-model="info.cforhmType"
                @on-change="changeSelect2($event, 'cforhmType')"
                placeholder="請選擇承運商"
              >
                <i-option
                  v-for="(item, index) in forwarderList"
                  :key="index"
                  :value="item.id"
                  >{{ item.ForwarderName }}</i-option
                >
              </i-select>
            </Form-item> -->
            <Form-item :label="$t('Mypackage.Choosepaymentmethod')" prop="PayType"
              style="position: absolute; left: 325px">
              <i-select style="width: 162px" v-model="info.PayType" @on-change="changeSelect2($event, 'PayType')"
                :placeholder="$t('Mypackage.Pleaseselectpaymentmethod')">
                <!-- info.ServiceType == 3 && isDf == 0? payDf : payList" -->
                <!-- ass -->
                <i-option v-for="(item, index) in info.ServiceType == 3 && isDf == 0
                  ? payDf
                  : payList" :key="index" :value="item.id">{{ item.pay }}</i-option>
              </i-select>
            </Form-item>
            <!-- <span
              style="position: absolute; width: 200px; right: 227px; color: red"
              v-show="Showzhu"
              >注:(支付寶,微信,轉數快支付會收取1%手績費(最小付款為使用PAYPAL會有手續費3.9%+$2.35手續費產生)</span
            > -->
          </div>
          <div class="info-flex" style="position: relative; left: -30px">
            <Form-item :label="$t('Mypackage.Selectroll')" prop="Jyj">
              <i-select style="width: 162px" v-model="info.Jyj" @on-change="changeSelect2($event, 'Jyj')"
                :placeholder="$t('Mypackage.Pleaseselecttheconsolidationvolume')">
                <!-- info.ServiceType == 3 && isDf == 0? payDf : payList" -->
                <!-- ass -->
                <i-option v-for="(item, index) in resList" :key="index" :value="item.ID" v-show="ShowJyj">{{ item.newName
                }}</i-option>
              </i-select>
            </Form-item>

            <Form-item :label="$t('Mypackage.Use')">
              <div class="tip-box">
                <i-input v-model="info.Useintegral" :placeholder="$t('Mypackage.UseOne')" @on-blur="UseintFs"></i-input>
                <div class="tips">
                  *{{ `當前積分${this.SuIntegral}，100積分可抵扣1RM。` }}
                </div>
              </div>
            </Form-item>
            <Form-item :label="$t('Mypackage.Insurance')">
              <div class="tip-box">
                <i-input v-model="info.Bj" :placeholder="$t('Mypackage.InsuranceOne')" @on-blur="sumOrderFree"></i-input>
                <div class="tips">
                  *{{ `保價費用：${this.freeAdd.BjFree ? this.freeAdd.BjFree : 0}` }}
                </div>
              </div>
            </Form-item>
          </div>
          <!-- <Form-item label="備註(選填)">
            <i-input placeholder="請輸入備註"></i-input>
          </Form-item> -->
          <Form-item>
            <i-button type="primary" class="btn-info"
              @click="handleSubmit('info')">{{ $t("Mypackage.Applicationconsolidation") }}</i-button>
          </Form-item>
        </i-form>
        <Spin size="large" fix v-if="spinShow"></Spin>
      </div>
    </r-mask>
    <r-mask :title="$t('Mypackage.Packagepicture')" :isShowModal="isShowImg" @closeMask="isShowImg = false">
      <div v-for="(item, index) in bagImg" :key="index">
        <img class="bagImg" :src="item.pic_path" alt="图片加载失败" />
      </div>
    </r-mask>
    <r-mask :title="$t('Mypackage.Ordersuccessful')" :isShowModal="showTaobaoCode" @closeMask="handleTaobao">
      <div class="link-box">
        <div>ID:{{ taobaoId }}</div>
        <div>
          {{ $t("Mypackage.Paymentcode") }}:{{ taobaoCode }}
          <Button-b value="複製" @click.native="copy" v-clipboard="taobaoCode"></Button-b>
        </div>
        <div class="linktaobao" @click="toLink">{{ $t("Mypackage.payTaobao") }}</div>
        <div>
          <p>提示：</p>
          <p>1：{{ $t("copyma") }}</p>
          <p>2：{{ $t("Mypackage.payTaobao") }}</p>
          <p>3：{{ $t("xdCopysss") }}</p>
        </div>
      </div>
    </r-mask>
    <r-mask :title="$t('zfbzf')" :isShowModal="isShowZfb" @closeMask="handleZfb">
      <!-- <img :src="zfbUrl" alt="图片未上传"/> -->
      <iframe class="wuliu" :src="zfbUrl"></iframe>
    </r-mask>
    <r-mask title="微信支付" :isShowModal="isShowwx" @closeMask="handleZfb" class="one">
      <div class="tip01">請打開微信掃描下方二維碼</div>
      <div id="WeChie"></div>
      <div class="tip02">支付金額：{{ this.freeAdd.Free }}RM</div>
      <!-- <img :src="'data:image/png;base64,'+Familywx" alt="图片未上传" /> -->
    </r-mask>
    <!-- 轉數快 -->
    <r-mask title="轉數快" :isShowModal="isShowKZ" @closeMask="handleZfb" class="one">
      <div class="tip01">請打開轉數快掃描下方二維碼</div>
      <!-- <div id="WeChie" style="margin: 20px 0 0 104px;"></div> -->
      <img :src="'data:image/png;base64,' + KZ" alt="图片未上传" />
      <div class="tip02">支付金額：{{ this.freeAdd.Free }}RM</div>
    </r-mask>
    <div class="stauts-top">
      <div>
        {{ $t("Mypackage.Selected") }}：{{ piece }} {{ $t("Mypackage.individual") }}，{{
          $t("Mypackage.Totalweight")
        }}：{{ weight }}kg
        <!-- weight -->
      </div>
      <div class="apply-btn" @click="applay">
        <Button-b :value="$t('Mypackage.Applicationconsolidation')" />
      </div>
      <div class="apply-btn" @click="setapplay">
        <Button-b :value="$t('Mypackage.BatchEdit')" />
      </div>
    </div>
    <!-- <div style="background:red;height:200px;width:200px">
      <img :src="'data:image/png;base64,'+KZ" alt="图片未上传" />
    </div> -->
    <!-- 确定集运对话框 -->
    <Modal v-model="Showdetailed" title="确定集运?" :loading="Showdetailedloading" @on-ok="addOrder" width="800px">
      <div>
        <h2 v-if="info.ServiceType == 2">
          出货渠道：{{ LabelShwo.substring(0, 6) ? LabelShwo : "送货上门" }}
        </h2>
        <h2 v-if="info.ServiceType == 3">
          出货渠道：{{ LabelShwo.substring(0, 6) ? LabelShwo : "自取" }}
        </h2>
        <!-- <i-table border stripe :columns="columnsBag" :data="sList"></i-table> -->
      </div>

      <!-- <div
        v-if="info.ServiceType == 2"
        style="margin-top: 10px; font-size: 18px; font-weight: bold; color: #e95098"
      >
        收货地址：聯系人：{{ Showps.Signer }}-- 手機號：{{ Showps.Phone }}-- 電話：{{
          Showps.Tel
        }}-- 地址：{{ Showps.CountryName }}- {{ Showps.ProviceName }}-{{
          Showps.CityName ? Showps.CityName : ""
        }}-{{ Showps.AreaName ? Showps.AreaName : "" }}-{{
          Showps.Address ? Showps.Address : ""
        }}
      </div> -->

      <h2 v-if="info.ServiceType == 3" style="margin-top: 10px；font-size:18px;font-weight:bold;color:#e95098">
        自提點：{{ ShowList.Name }}- 地址：{{ ShowList.Address }}- 手機號：{{
          ShowList.Phone
        }}- 電話：{{ ShowList.Tel }}- 最大重量限制：{{ ShowList.MaxWeight }}-
        最大重量限制：{{ ShowList.IsDf == 1 ? "是" : "否" }}
      </h2>

      <!-- <div
        v-show="ShowpsFalse"
        style="margin-top: 10px; font-size: 18px; font-weight: bold; color: #e95098"
      >
        <div v-for="(item, index) in addressList" :key="index">
          <div v-if="index < 1">
            收货地址：聯系人：{{ item.Signer }} -- 手機號：{{ addressList.Phone }} --
            電話：{{ item.Tel }} 地址：{{
              addressList.CountryName ? addressList.CountryName : ""
            }}
          </div>
        </div>
      </div> -->
    </Modal>
  </div>
</template>

<script>
import pageScroll from './PageScroll.vue'
import QRCode from "qrcodejs2";
import { baseInfo, delBag, AddressCol } from "./index.js";
export default {
  inject: ["reload"],
  components: { pageScroll },
  data() {
    return {
      search: "",
      Showdetailed: false,
      Showdetailedloading: false,
      LabelShwo: "",
      ShowpsFalse: false,
      Showps: {},
      ShowList: {},
      setshowModal: false,
      goodsName: [
        "衣服",
        "鞋子",
        "包包",
        "家居用品",
        "家具",
        "食品",
        "化妝品",
        "汽車用品",
        "個人護理產品",
        "文具",
        "植物",
        "廚房用品",
        "裝修建材",
        "電子產品",
        "其他",
      ],

      // columnsBag: [
      //   {
      //     title: "快遞單號",
      //     key: "kdBillCode",
      //     width: 180,
      //     align: "center",
      //   },
      //   {
      //     title: "快遞公司",
      //     key: "kdCompany",
      //     width: 100,
      //     align: "center",
      //   },
      //   {
      //     title: "實重",
      //     key: "Weight",
      //     width: 100,
      //     align: "center",
      //   },
      //   {
      //     title: "體積重",

      //     key: "Weight2",
      //     //   `单号:${arr.length ? arr[0].name : ''}物流状态`
      //     width: 100,
      //     align: "center",
      //   },

      //   {
      //     title: "尺寸（CM）",
      //     key: "Size",
      //     width: 120,
      //     align: "center",
      //   },
      //   {
      //     title: "貨物品名",
      //     key: "goods",
      //     width: 100,
      //     align: "center",
      //   },

      //   {
      //     title: "貨物類型",
      //     key: "goodstyep",
      //     width: 100,
      //     align: "center",
      //   },
      //   // {
      //   //   title: "超長費",
      //   //   key: "longFree",
      //   //   width: 100,
      //   //   align: "center",
      //   // },
      //   {
      //     title: "到庫時間",
      //     key: "dd_time",
      //     width: 180,
      //     align: "center",
      //   },
      //   // {
      //   //   title: "仓租",
      //   //   key: "Cz",
      //   //   width: 100,
      //   //   align: "center",
      //   // },
      //   {
      //     title: "超长费",
      //     key: "LongFree",
      //     width: 100,
      //     align: "center",
      //   },
      //   // {
      //   //   title: "附加费",
      //   //   key: "AddFree",
      //   //   width: 100,
      //   //   align: "center",
      //   // },
      // ],
      addTable: [
        {
          title: "選擇",
          width: 120,
          align: "center",
          // defaultS: "",
          render: (h, params) => {
            let defaultS = false;
            let id = params.row.ID;
            let CountryID = params.row.Country;
            let _this = this;
            let type = this.info.ServiceType;
            if (type == 2) {
              defaultS = this.info.Address == id;
            }
            if (type == 3) {
              defaultS = this.info.Ztd == id;
            }
            return h("div", [
              h("Radio", {
                props: {
                  value: defaultS,
                  size: "large",
                },
                on: {
                  input: function () {
                    console.log(_this.info.ServiceType);
                    
                    if (_this.info.ServiceType == 2) {
                      _this.info.Address = id;
                      _this.info.CountryID = CountryID;
                      _this.Showps = params.row;
                      _this.info.AirTname = ''
                      if (_this.info.Address !== "") {

                        _this.sumOrderFree("add");
                      }
                    }
                    if (_this.info.ServiceType == 3) {
                      // _this.QueryZtd();
                      _this.info.Address = 0;
                      _this.info.Ztd = id;
                      _this.isDf = params.row.IsDf;
                      _this.ShowList = params.row;
                      if (_this.info.Ztd !== "") {
                        _this.sumOrderFree("add");
                      }
                      //_this.sumOrderFree("add");
                    }
                  },
                },
              }),
            ]);
          },
        },
        {
          title: "地址",
          align: "center",
          ...AddressCol(this),
        },
        // {
        //   title: "附加費",
        //   align: "center",
        //   width: 120,
        //   render: (h, params) => {
        //     let row = params.row;
        //     let str = `$${row.AddFree}`;
        //     return h("span", str);
        //   },
        // },
      ],
      columns: [
        {
          type: "selection",
          width: 80,
          align: "center",
        },
        {
          title: this.$t('Forecastpackage.PackageInfo'),
          // key: "name",
          width: 300,
          align: "letf",
          render: (h, params) => {
            return h("div", [
              h("div", [
                h("div", {
                  domProps: {
                    style: "display:flex;line-height: 25px",
                    innerHTML: `<div style="width: 260px;" >${this.$t(
                      "bag.billCode"
                    )}：<span style="color: #999;font-weight:bold;">${params.row.kdBillCode
                      }</span></div>`,
                  },
                }),
                h("div", {
                  domProps: {
                    style: "display:flex;line-height: 25px",
                    innerHTML: `<div style="width: 220px">${this.$t(
                      "bag.size"
                    )}：<span style="color: #515a6e">${params.row.Size ? params.row.Size : "0 * 0 * 0"
                      }</span></div>`,
                  },
                }),
                h("div", {
                  domProps: {
                    style: "display:flex;line-height: 25px",
                    innerHTML: ` 
              <div style="width: 260px">${this.$t(
                      "bag.realWeight"
                    )}：<span style="color: #515a6e">${params.row.Weight}
              （kg）</span></div>
                  `,
                  },
                }),
                h("div", {
                  domProps: {
                    style: "display:flex;line-height: 25px",
                    innerHTML: ` 
              <div style="width: 260px">${this.$t(
                      "bag.bulkWeight"
                    )}：<span style="color: #515a6e">${params.row.Weight2}
              （kg）</span></div>
                  `,
                  },
                }),
                h("div", {
                  domProps: {
                    style: "display:flex;line-height: 25px",
                    innerHTML: `  <div style="width: 260px;">${this.$t(
                      "Forecastpackage.goodsvale"
                    )}：<span style="color: #515a6e">${params.row.GoodsValue ? params.row.GoodsValue : "0.00"
                      } </span></div>`,
                  },
                }),

                h("div", {
                  domProps: {
                    style: "display:flex;line-height: 25px",
                    innerHTML: `  <div style="width: 260px;">${this.$t(
                      "bag.inHouseTime"
                    )}：<span style="color: #515a6e">${params.row.dd_time
                      ? params.row.dd_time
                      : this.$t("bag.waitHouse")
                      }</span></div>
                  `,
                  },
                }),
                h("div", {
                  domProps: {
                    style: "display:flex;line-height: 25px",
                    innerHTML: '<div style="width: 400px;">' + this.$t(
                      "bag.upTime"
                    ) + (params.row.inplaceTime ? '：<span style="color: #515a6e">' + params.row.inplaceTime : ' <span style="color: red;font-weight:bold;">' + this.$t("bag.noUP"))
                      + '</span></div>',
                  },
                }),
                h("div", {
                  domProps: {
                    style: "display:flex;line-height: 25px",
                    innerHTML: params.row.noMerge ? '<div style="width: 260px;"><span style="color: rgb(241, 31, 31);font-weight:600;">' + this.$t("bag.noMerge") + '</span></div>' : '',
                  },
                }),
              ]),
            ]);
          },
        },
        {
          title: this.$t('Home.Warehouse'),
          key: "HouseName",
          width: 100,
          align: "center",
        },
        {
          title: this.$t('Personal.Type'),
          key: "goodsName",
          width: 100,
          align: "center",
        },
        {
          title: this.$t('Mypackage.Product'),
          key: "goods",
          width: 100,
          align: "center",
        },
        {
          title: this.$t('Mypackage.Quantity'),
          key: "Number",
          width: 100,
          align: "center",
        },
        {
          title: this.$t('BZ'),
          key: "goods_memo",
          width: 110,
          align: "center",
          render: (h, params) => {
            return h("span", params.row.goods_memo ? params.row.goods_memo : "无");
          },
        },
        {
          title: this.$t('PromotionCenter.operation'),
          width: 120,
          align: "center",
          fixed: "right",
          ...delBag(this),
        },
      ],
      addressid: {
        Country: 0,
        Provice: 0,
        City: 0,
        Area: 0,
      },
      addList: {
        Provice: [],
        City: [],
        Area: [],
        Country: [],
      },
      list: [],
      loading: true,
      showTable: true,
      formInline: {
        Memberid: localStorage.getItem("userID"),
        kdBillcode: "",
        Goods: [],
        Goodsid: "",
        GoodsType: "",
        Goods_meno: "",
        Number: 1,
        Immediatrly: 0,
        GoodsValue: "",
        ID: "",
        ClientName: localStorage.getItem("name"),
      },
      formInlines: {
        Memberid: localStorage.getItem("userID"),
        GoodsValue: "",
        ClientName: localStorage.getItem("name"),
      },
      GoodList: [],
      showModal: false,
      ruleInline: {
        kdBillcode: [
          { required: true, message: "快遞單號不能為空！", trigger: "change" },
        ],
        // Goods: [{ required: true, message: "品名不能為空！", trigger: "change" }],
        Goodsid: [
          {
            required: true,
            message: "請選擇貨物類型",
            trigger: "change",
            type: "number",
          },
        ],
        Number: [
          {
            required: true,
            message: "貨物數量不能為空",
            trigger: "change",
            type: "string",
          },
        ],
      },
      ruleValidate2: {
        AirTname: [
          {
            required: true,
            message: "請選擇時效",
            trigger: "change",
            type: "number",
          },
        ],
        cforhmType: [
          {
            required: true,
            message: "請選擇承運商",
            trigger: "change",
            type: "number",
          },
        ],
        PayType: [
          {
            required: true,
            message: "請選擇付款方式",
            trigger: "change",
            type: "number",
          },
        ],
        mobile: [
          {
            required: true,
            message: "請輸入手機號",
            trigger: "blur"
          },
        ],
      },
      tabIndex: 0,
      sList: [],
      showApplay: false,
      info: {
        Client: localStorage.getItem("userID") * 1, //会员ID
        BillCode: [], //快递单号集合
        WaveID: 5, //仓库ID
        AirTname: "", //	航班ID
        Address: "", //	收货地址ID
        Useintegral: 0, //使用积分数量 不使用积分时传入0
        Jyj: 0, //	集运卷ID，不使用集运券的时候传入 0
        Is_Bs: true, //  是否包税
        Bj: 0, //  保价金额
        Dshk: 0, // 代收货款
        CountryID: 0, //  国家ID
        GoodsType: "", //	货物类型名称
        cforhmType: "香港专线", //  承运商名称
        ServiceType: 2, //	服务方式
        PayType: 2, //	支付方式
        Ztd: 0,
        mobile: "",
        Signer: "",
        come: "pc网站下单",
      },
      payDf: [
        { id: 2, pay: this.$t("Balancepayment") },
        // { id: 3, pay: "淘寶店支付" },
        // { id: 23, pay: "轉數快" },
        // { id: 12, pay: "支付寶" },
        // { id: 11, pay: "微信支付" },
        { id: 100, pay: this.$t("TransferAccounts") },
        // { id: 66, pay: "PAYPAL/信用卡" },
        // { id: 47, pay: this.$t("Ipay88") },
      ], //支付列表
      payList: [
        // { id: 1, pay: "貨到付款" },
        { id: 2, pay: this.$t("Balancepayment") },
        // { id: 3, pay: "淘寶店支付" },
        // { id: 23, pay: "轉數快" },
        // { id: 12, pay: "支付寶" },
        // { id: 11, pay: "微信支付" },
        { id: 100, pay: this.$t("TransferAccounts") },
        // { id: 66, pay: "PAYPAL/信用卡" },
        // { id:26,pay:'微信端JSAPI支付'}
        // { id: 11, pay: "微信支付" },
        // { id: 12, pay: "支付寶支付" },
        // { id: 47, pay: this.$t("Ipay88") },
      ],
      isDf: 1,
      ServiceType: [
        {
          label: "送貨上門",
          value: 2,
        },
        {
          label: "自提點",
          value: 3,
        },
      ],
      ztList: [],
      addressList: [],
      forwarderList: [],
      timeBar: [],
      freeAdd: {},
      SuIntegral: "",
      resList: [],
      currentId: 0,
      spinShow: false,
      bagImg: [],
      isShowImg: false,
      showTaobaoCode: false,
      taobaoId: "",
      taobaoCode: "",
      isShowZfb: false,
      isShowwx: false,
      isShowKZ: false,
      zfbUrl: "",
      time: "",
      key: "key1",
      active: 0,
      total: {
        all: 0,
        nowAll: 0,
        afterAll: 0,
      },
      CountryList: [],
      choseIndex: 0,
      KZ: "",
      Familywx: "",
      GoosMoaol: [],
      newPs: [],
      newZt: [],
      timer: null,
      orderId: "",
      Showzhu: false,
      ShowJyj: true,
      // Familyzfb:""
      ipay: {},

      billT: undefined
    };
  },
  computed: {
    arrSx: function () {
      return this.info.ServiceType == 2 ? this.newPs : this.newZt;
    },
    piece() {
      return this.sList.length;
    },
    weight() {
      let sum = 0;
      this.sList.forEach((item) => {
        sum += item.Weight;
      });
      return sum;
    },
    columnsBag() {
      return [
        {
          title: this.$t('Forecastpackage.couriernumber'),
          key: "kdBillCode",
          width: 180,
          align: "center",
        },
        {
          title: this.$t('kdgs'),
          key: "kdCompany",
          width: 100,
          align: "center",
        },
        {
          title: this.$t('sz'),
          key: "Weight",
          width: 100,
          align: "center",
        },
        {
          title: "材积重",
          key: "Weight2",
          width: 100,
          align: "center",
        },

        {
          title: "尺寸（CM）",
          key: "Size",
          width: 120,
          align: "center",
        },
        {
          title: this.$t('Forecastpackage.Namegoods'),
          key: "goods",
          width: 100,
          align: "center",
        },

        {
          title: this.$t('Forecastpackage.Typeofgoods'),
          key: "goodstyep",
          // goodsName
          width: 100,
          align: "center",
        },
        // {
        //   title: "超長費",
        //   key: "longFree",
        //   width: 100,
        //   align: "center",
        // },
        {
          title: this.$t('dksj'),
          key: "dd_time",
          width: 180,
          align: "center",
        },
        // {
        //   title: "仓租",
        //   key: "Cz",
        //   width: 100,
        //   align: "center",
        // },
        {
          title: this.$t('ccf'),
          key: "LongFree",
          width: 100,
          align: "center",
        },
        // {
        //   title: "附加费",
        //   key: "AddFree",
        //   width: 100,
        //   align: "center",
        // },
      ]
    },
  },
  watch: {
    $route() {
      if (this.$route.query && this.$route.query.key) {
        this.changeTab(parseInt(this.$route.query.key));
      }
    },
    "info.PayType"(newVal) {

    },
  },

  created() {
    // this.queryBillCode(this.tabIndex);
    this.Showps = "";
    if (this.Showps == "") {
      this.ShowpsFalse = true;
    }

    // this.QueryGoods();
    if (this.$route.query && this.$route.query.key) {
      this.changeTab(parseInt(this.$route.query.key));
    }
    // this.queryBillCode();
    let msg = JSON.parse(localStorage.getItem("msg"));
    this.info.Signer = msg.ClientName;
    this.info.mobile = msg.Mobile;
    // if (this.info.mobile == null) {
    //   this.info.mobile == 0;
    // }
  },
  methods: {
    // 使用積分
    UseintFs() {
      if (this.freeAdd.Free < 50) {
        this.$Message.error("運費小於50不能使用積分!");
        this.info.Useintegral = 0;  // zhes
        return false;
      } else if (this.info.Useintegral >= (this.freeAdd.Free / 10 * 2 * 100)) {
        this.$Message.error("積分最多抵抗運費的百分之20!");
        this.info.Useintegral = 0;  // zhes
        return false;
      } else {
        this.sumOrderFree();
      }
    },
    async BillCode() {
      const { data } = await this.$post("QueryBillCode", {
        BillCode: this.search,
        Client: localStorage.getItem("userID"),
        OrdeTeyp: 0,
      });
      console.log(data);
      
      if (data.State) {
        this.list = JSON.parse(data.ReturnJson);
        console.log(this.list);
      }
    },
    // async BillCode() {
    //   const { data } = await this.$post("BillCode", {
    //     BillCode: this.search,
    //   });
    //   if (data.State) {
    //     this.list = JSON.parse(data.ReturnJson);
    //   }
    // },
    async sumOrderFree(change) {
      // this.$Spin.show({
      //   render: (h) => {
      //     return h("div", [
      //       h("Icon", {
      //         class: "demo-spin-icon-load",
      //         props: {
      //           type: "ios-loading",
      //           size: 22,
      //         },
      //       }),
      //       h("div", "正在加載請稍後"),
      //     ]);
      //   },
      // });
      // this.$Spin.show();
      let id = [];
      for (let i = 0; i < this.sList.length; i++) {
        id.push(this.sList[i].id);
      }

      this.info.BillCode = id;
      if (
        this.info.Address == "" &&
        this.addressList.length > 0 &&
        this.info.ServiceType == 2
      ) {
        //this.info.Address = this.addressList[0].ID;

      }
      // this.info.Address = this.info.Address * 1;
      this.info.Useintegral = this.info.Useintegral * 1;
      this.info.Bj = this.info.Bj * 1;
      const { data } = await this.$post("SumOrderFree", this.info);
      this.sList = JSON.parse(data.ReturnJson).BillCodeInfo
      if (data.State) {
        this.freeAdd = JSON.parse(data.ReturnJson);
        this.addressList = this.freeAdd.Client_Address;
        this.info.GoodsType = this.freeAdd.GoodsType;

        if (this.addressList.length) {
          this.info.CountryID = this.addressList[0].Country;

        }
        this.forwarderList = this.freeAdd.Forwarder;
        if (this.freeAdd.SuIntegral) {
          this.SuIntegral = this.freeAdd.SuIntegral;
          if (this.SuIntegral < 0) {
            this.SuIntegral = 0;
          }
        }
        //获取时效列表
        this.timeBar = this.freeAdd.TimeBar.map((item) => {
          item.Name = `${item.timeBarName}(${item.Rem})`;
          return item;
        });
        this.newPs = this.timeBar.filter((item) => {
          return item.timeBarName.indexOf("Self") == -1;
        });
        this.newZt = this.timeBar.filter((item) => {
          return item.timeBarName.indexOf("Self") != -1;
        });
        if (this.info.AirTname == "" || change) {
          this.info.AirTname = this.arrSx[0].id;
          this.info.cforhmType = this.forwarderList[0].id;
        }
        this.queryFreightVolume();
      } else {
        if (data.MsgText == "当前店铺未维护对应当前状态的报价,请核查！") {
          this.$Message.error("请选择与货物类型对应的出货渠道");
        }
        this.freeAdd = JSON.parse(data.ReturnJson);
        this.timeBar = this.freeAdd.TimeBar.map((item) => {
          item.Name = `${item.timeBarName}(${item.Rem})`;
          return item;
        });
        this.newPs = this.timeBar.filter((item) => {
          return item.timeBarName.indexOf("Self") == -1;
        });
        // this.newZt = this.timeBar
        this.newZt = this.timeBar.filter((item) => {
          return item.timeBarName.indexOf("Self") != -1;
        });
        if (this.info.AirTname == "" || change) {
          this.info.AirTname = this.arrSx[0].id;
          this.info.cforhmType = this.forwarderList[0].id;
        }
        this.freeAdd = {};
      }
    },
    async addOrder() {
      if (this.info.ServiceType == 3) {
        if (this.info.Signer == "" || this.info.mobile == "") {
          this.$Message.error("請填寫收件人信息!");
          return false;
        } else if (this.info.mobile == null) {
          this.$Message.error("請填寫收件人信息!");
          return false;
        }
      }
      this.spinShow = true;
      const { data } = await this.$post("AddOrder", this.info);
      if (data.State) {
        this.spinShow = false;
        this.orderId = data.MsgText;
        let type = this.info.PayType;
        if (type == 2 || type == 1) {
          // 余额支付
          this.$Message.success("集運成功！");
          this.closeMask();
          this.queryBillCode(this.tabIndex);
          this.$router.push("./myOrder");
        }
        if (type == 100) {
          this.$router.push({
            path: "./banktransfer",
            query: {
              orderCode: JSON.parse(data.ReturnJson).OrderCode,
              money: JSON.parse(data.ReturnJson).Free
            },
          });
          // this.$router.push("/banktransfer");
        }
        if (type == 3) {
          // 淘宝店支付
          this.$Message.success("集運成功！");
          this.closeMask();
          this.taobaoCode = JSON.parse(data.ReturnJson).OrderCode;
          this.taobaoId = JSON.parse(data.ReturnJson).ID;
          this.showTaobaoCode = true;
        }
        if (type == 11) {
          // 微信支付
          this.isShowwx = true;
          // this.Familywx = data.ReturnJson
          this.$nextTick(() => {
            document.getElementById("WeChie").innerHTML = "";
            let WeChie = new QRCode("WeChie", {
              width: 150,
              height: 150,
              text: data.ReturnJson, // 二维码地址
              colorDark: "#000",
              colorLight: "#fff",
            });
          });

          this.timer = setInterval(this.QueryOrderState, 2000);
        }
        if (type == 12) {
          // 支付宝支付
          this.isShowZfb = true;
          this.zfbUrl = data.ReturnJson;
          this.timer = setInterval(this.QueryOrderState, 2000);
        }
        if (type == 23) {
          this.isShowKZ = true;
          this.KZ = data.ReturnJson;
          this.timer = setInterval(this.QueryOrderState, 2000);
        }
        if (type == 66) {
          // 支付宝支付
          this.$router.push("./myOrder");
          window.open(data.MsgText);
        }
        if (type == 47) {
          this.ipay = JSON.parse(data.ReturnJson)
          window.open('https://api.best-muster.com/Payment/CallPayMent?MemberId=' + this.ipay.MemberId + '&Type=2' + '&OrderId=' + this.ipay.OrderId + '&Amount=' + this.ipay.Amount + '&Redirect_Url=https://member.best-muster.com/#/myOrder' + '&Description=订单支付')
        }
      } else {
        this.$Message.error(data.MsgText);
      }
      this.spinShow = false;
    },
    searchBill() {
      if (this.billT) {
        clearTimeout(this.billT);
      }
      this.billT = setTimeout(async () => {
        this.$refs.scroll.refrushTable();
      }, 200);
    },
    async queryBillCode(index) {
      this.loading = true;
      const result = {};
      const JsonData = {
        Client: localStorage.getItem("userID"),
        OrdeTeyp: this.tabIndex,
      };
      const { data } = await this.$post("QueryBillCode", JsonData);
      if (data.State) {
        this.list = JSON.parse(data.ReturnJson);
        
        // this.dList = this.list;
        let arr = JSON.parse(data.ReturnJson2);
        if (arr.length > 0) {
          this.total.all = arr[0].sum;
          this.total.nowAll = arr[1] && arr[1].sum;
          this.total.afterAll = arr[2] && arr[2].sum;
        }
        if (this.tabIndex == 2) {
          this.list = this.list.filter((item) => {
            item._disabled = !item.Cotron;
            //  item._disabled = !item.Is_Yb;
            item.checkboxShow = true;
            return item.inplaceTime !== null;
          });
        } else if (this.tabIndex == 0) {
          this.list = this.list.filter((item) => {
            item._disabled = true;
            // item._disabled = !item.Cotron;
            // item.checkboxShow = true;
            return item.dd_time !== null;
          });
        } else {
          this.list.forEach((item) => {
            item._disabled = true;
            item.checkboxShow = false;
          });
        }
        // this.list.forEach((item) => {
        //   item._disabled = !item.Cotron;
        // });
        this.loading = false;
        result.data = this.list
        result.total = this.list.length;
        console.log(this.list);
        
        return result
      }
    },
    async delBillCode({ row, index }) {
      const JsonData = {
        MemberId: localStorage.getItem("userID"),
        ID: row.id,
      };
      const { data } = await this.$post("DelBillCode", JsonData);
      if (data.State) {
        this.list.splice(index, 1);
        this.$Message.success(`單號${row.kdBillCode} : 刪除成功！`);
      }
    },
    async GetTimeliness() {
      const JsonData = {
        CountryID: 852,
        WaveID: this.info.WaveID,
      };
      const { data } = await this.$post("GetTimeliness", JsonData);
      if (data.State) {
        //获取时效列表
        let arr = JSON.parse(data.ReturnJson).filter((item) => {
          return item.Name.indexOf("自取") != -1;
        });
        this.info.AirTname = arr[0].ID;
      }
    },
    async queryGoods() {
      const JsonData = {
        MemberId: localStorage.getItem("userID"),
      };
      const { data } = await this.$post("QueryGoods", JsonData);
      if (data.State) {
        this.GoodList = JSON.parse(data.ReturnJson);
      }
    },
    async setbag() {
      if (this.formInlines.GoodsValue == '' || this.formInlines.Goods == '') {
        this.$Message.error("請先填写完整信息！");
        return false
      }
      let valueList = []
      for (var i = 0; i < this.sList.length; i++) {

        valueList.push(this.sList[i].id)
      }
      var JsonData = {
        ids: valueList.toString(),
        goodsValue: this.formInlines.GoodsValue,
        goods: this.formInlines.Goods
      };
      //     if(this.setgoodsValue==""||this.setgoodsValue==undefined){
      // this.$Message.error("货物价值不能为空");
      // return false
      //     }
      //     else{ }
      const { data } = await this.$post("Update_Goodsvalue", JsonData);
      if (data.State) {
        this.setshowModal = false;
        // this.queryBillCode(this.tabIndex);
        this.searchBill()
        this.$Message.success("修改成功！");
      } else {
        this.$Message.error(data.MsgText);
      }
    },
    async upDateBag() {
      this.formInline.Number = this.formInline.Number * 1;
      // this.formInline.Goods = this.GoosMoaol.join(",");
      // if (this.formInline.Goods == "") {GoodsValue
      //   this.$Message.error("品名不能为空!");
      //   return false;
      // }
      const { data } = await this.$post("UpdateBillCode", this.formInline);
      if (data.State) {
        this.showModal = false;
        // this.queryBillCode(this.tabIndex);
        // this.billT = undefined
        this.searchBill()
        this.$Message.success("修改成功！");
      } else {
        this.$Message.error(data.MsgText);
      }
    },
    async queryAdressByMemberID() {
      const JsonData = {
        MemberId: localStorage.getItem("userID"),
      };
      const { data } = await this.$post("QueryAdressByMemberID", JsonData);
      if (data.State) {
        this.addressList = JSON.parse(data.ReturnJson).filter((item) => {
          return item.Chk == 1;
        });
        // if (this.addressList.length == 0) {
        //   this.$Message.error("暫無可用地址，請先添加地址！");
        // } else {
        //   this.showApplay = true;
        //   this.GetAllZtd();
        //   this.getCountryList();
        // }
        this.showApplay = true;
        this.GetAllZtd();
        this.getCountryList();
      }
    },
    async getCarrier() {
      const para = {
        AirTname: this.info.AirTname,
        WaveID: this.info.WaveID,
        CountryID: this.info.CountryID,
        CusID: localStorage.getItem("CusID"),
        Token: localStorage.getItem("token"),
      };
      const { data } = await this.$post("GetCarrier", para, true);
      if (data.State) {
        this.forwarderList = JSON.parse(data.ReturnJson);
      } else {
        // this.$Message.error(data.MsgText);
      }
    },
    async queryFreightVolume() {
      let _this = this;
      const para = {
        freight: _this.freeAdd.Z_Free,
        weight: _this.freeAdd.Z_Weight,
        token: localStorage.getItem("token"),
      };
      const { data } = await this.$post("QueryConvertibleVolume", para, true);

      if (data.State) {
        this.resList = JSON.parse(data.ReturnJson).QueryFreightVolumeinfo;
        this.resList = this.resList.map((item, index) => {
          item.newName = `${item.VolumeCome}${item.Volume}$`;
          return item;
        });

      } else {
        // this.$Message.warning(data.MsgText);
      }
    },
    async GetAllZtd() {
      const { data } = await this.$post("QueryZtd", this.addressid);
      if (data.State) {
        this.ztList = JSON.parse(data.ReturnJson);
        //this.info.Ztd = this.ztList.length > 0 ? this.ztList[0].ID : 0;
        this.isDf = this.ztList.length > 0 ? this.ztList[0].IsDf : 0;
        // this.sumOrderFree(true);
        // this.ShowList = this.ztList[0];
      }
    },
    async getCountryList() {
      const params = { MemberID: localStorage.getItem("userID") };
      const { data } = await this.$post("GetCountryList", params);
      if (data.State) {
        this.CountryList = JSON.parse(data.ReturnJson);
      }
    },

    async changeAddress(e, key) {
      this.info.Address = "";
      this.info.Ztd = "";
      switch (key) {
        case "Country":
          this.addList.Provice = [];
          this.addList.City = [];
          this.addList.Area = [];
          this.addressid.Provice = 0;
          this.addressid.City = 0;
          this.addressid.Area = 0;
          break;
        case "Provice":
          this.addList.City = [];
          this.addList.Area = [];
          this.addressid.City = 0;
          this.addressid.Area = 0;
          break;
        case "City":
          this.addList.Area = [];
          this.addressid.Area = 0;
          break;
      }
      this.addressid[key] = e;
      const params = {
        ParentID: key == "Country" ? 0 : e,
        CountryID: this.addressid.Country,
      };
      this.GetAllZtd();
      const { data } = await this.$post("GetAreaByParentID", params);
      if (data.State) {
        this.addList[key] = JSON.parse(data.ReturnJson);
      }
    },

    async QueryOrderState() {
      var JsonData = {
        OrderId: this.orderId,
      };
      const { data } = await this.$post("QueryOrderState", JsonData);
      if (data.State) {
        this.$Message.success("支付成功！");
        this.$router.push(`./myOrder`);
        window.clearInterval(this.timer);
      }
    },
    // async queryPayRequest() {
    //   var JsonData = {
    //     PayMode: this.info.PayType == 11 ? 0 : 1,
    //     OrderCode: this.time,
    //   };
    //   const { data } = await this.$post("queryPayRequest", JsonData);
    //   if (data.State) {
    //     this.$Message.success("支付成功！");
    //       this.isShowPay = false;
    //      this.showZfb = false;
    //     window.clearInterval(this.timer);
    //   }
    // },
    changeRadio(e) {
      this.info.ServiceType = e;
    },
    setapplay() {
      if (this.sList.length == "") {
        this.$Message.error("請先選擇要修改的包裹！");
        return false;
      } else {
        this.setshowModal = true
      }
      // this.info.WaveID = this.sList.length > 0 && this.sList[0].HouseId;
      // this.queryAdressByMemberID();
    },
    applay() {
      if (this.sList.length == "") {
        this.$Message.error("請先選擇要集運的包裹！");
        return false;
      }
      let pm = this.sList.some((item) => {
        return item.goods == "";
      });
      let type = this.sList.some((item) => {
        return item.goodsName != this.sList[0].goodsName;
      });
      let gdval = this.sList.some((item) => {
        return item.GoodsValue == 0 || item.GoodsValue == null || item.GoodsValue == '';
      });
      if (pm) {
        this.$Message.error("訂單品名不能為空!");
        return false;
      }
      // if (type) {
      //   this.$Message.error("货物类型不统一!");
      //   return false;
      // }
      if (gdval) {
        this.$Message.error("货物价值不能为空!请修改后申请集运");
        return false;
      }
      this.info.WaveID = this.sList.length > 0 && this.sList[0].HouseId;
      this.queryAdressByMemberID();
    },

    closeMask() {
      this.showApplay = false;
      this.initApplay();
    },
    initApplay() {
      this.info.Bj = 0;
      this.info.Useintegral = 0;
    },
    closeEdit() {
      this.showModal = false;
    },
    setcloseEdit() {
      this.setshowModal = false;
    },
    selectList(e,data) {
      const li = [];
      if (e.length == 0) {
        data.forEach((c) => {
          if (!c.contraband) c._disabled = false;
          c._checked = false;
        });
        data.push({});
        data.splice(data.length - 1, 1);
      } else if (e[0].noMerge && e.length == 1) {
        data.forEach((c) => {
          if (c.id != e[0].id) {
            c._disabled = true;
            c._checked = false;
          } else {
            c._checked = true;
            li.push(c);
          }
        });
        data.push({});
        data.splice(data.length - 1, 1);
      } else if (e.length == data.length) {
        data.forEach((c) => {
          if (c.noMerge) {
            c._disabled = true;
            c._checked = false;
          } else if (e.some(a => a.id == c.id)) {
            c._checked = true;
            li.push(c);
          }
        });
        data.push({});
        data.splice(data.length - 1, 1);
      } else {
        li.push(...e);
      }
      this.sList = e;
      this.info.WaveID = e.length > 0 && e[0].HouseId;
    },
    changeTab(e) {
      this.tabIndex = e;
      this.sList = [];
      this.info.BillCode = "";
      this.searchBill();
      // this.queryBillCode(e);
      
    },
    close_btn() {
      this.showApplay = false;
      this.info.Jyj = 0;
      this.info.AirTname = "";
      this.info.cforhmType = "";
      this.info.CountryID = 0;
      this.info.ServiceType = 2;
      this.addressid.Country = 0;
      this.addressid.Provice = 0;
      this.addressid.City = 0;
      this.addressid.Area = 0;
      this.info.GoodsType = ''

    },
    changeSelect3(val, type) {
      this.LabelShwo = val.label;
      var key = val.value;
      this.choseIndex = val.label.split(",")[1];
      this.info[type] = key;
      if (type == "AirTname") {
        this.sumOrderFree();
        this.getCarrier();
      }
      // if (key == "cforhmType") {
      //  this.queryFreightVolume();
      //}
      if (type == "PayType") {
      }
    },
    changeSelect(e) {
      this.formInline["GoodsType"] = e && e.label;
    },
    changeSelect2(e, key) {

      if (e == 3 || e == 2 || e == 1 || e == 66) {
        this.Showzhu = false;
      } else {
        this.Showzhu = true;
      }
      this.info[key] = e;
      if (key == "AirTname") {
        this.info.cforhmType = "";
        this.getCarrier();
      }
      if (this.info.Address > 0 || this.info.Ztd > 0) {
        // this.Showdetailed = true;
        this.sumOrderFree();
      } else {
        this.$Message.error("請選擇您地址!");
      }
    },
    changeZt(e) {
      this.info.ServiceType = e + 2;
      this.info.Address = "";
      this.info.Ztd = "";
      this.freeAdd.Free_Weight = "";
      this.freeAdd.Free = "";
      this.freeAdd.CountryMoney = "";
      this.freeAdd.CountryMoneyUnit = "";
      if (this.arrSx.length > 0) {
        this.info.AirTname = this.arrSx[0].id;
      }
      if (e == 0) {
        this.info.Ztd = 0;
        this.info.AirTname = "";
        // this.info.Address = this.addressList.length ? this.addressList[0].ID : 0;
        if (this.addressList.length == 0) {
          this.info.CountryID = 0;
        }
        // this.sumOrderFree()
      }
      if (e == 1) {
        //自提点
        // this.$Message.error("暫無自提點！")
        // return false;
        this.info.Address = 0;
        this.info.CountryID = 861;
        this.info.cforhmType = 1;
        this.GetTimeliness();
        this.changeAddress(861, "Country");
        // this.changeAddress(3579, "Provice");

        // this.info.Ztd = this.ztList.length > 0 ? this.ztList[0].ID : 0;
        // this.info.Address = 0;
        // this.info.CountryID = 861;
        // this.info.Provice = 3579;
        // this.info.cforhmType = 1;
        // this.GetTimeliness();
        // this.changeAddress(861, "Country");
        // this.changeAddress(3579, "Provice");
      }
    },
    changeModal(row) {
      this.formInline.kdBillcode = row.kdBillCode;
      this.formInline.Goods = row.goods;
      this.formInline.Goodsid = row.goods_id;
      this.formInline.GoodsType = row.goodstyep;
      this.formInline.Goods_meno = row.goods_memo;
      this.formInline.Number = JSON.stringify(row.Number);
      this.formInline.GoodsValue = row.GoodsValue
      this.formInline.ID = row.id;
      this.showModal = true;
    },
    setchangeModal() {
      this.showModal = true;
    },
    async showImg(row) {

      var JsonData = {
        BillCode: row.kdBillCode,
      };
      const { data } = await this.$post("QueryImageByBillCode", JsonData);
      if (data.State) {
        this.bagImg = JSON.parse(data.ReturnJson)
        if (JSON.parse(data.ReturnJson).length > 0) {
          this.isShowImg = true;
        } else {
          this.$Message.error("該包裹暫無圖片!");
          return false;
        }
      }
    },

    delModal(row) {
      this.$Modal.confirm({
        title: "提示",
        content: `確定要刪除：單號${row.row.kdBillCode}的包裹嗎？`,
        onOk: () => {
          this.delBillCode(row);
        },
        onCancel: () => {
          this.$Message.info("取消操作");
        },
      });
    },
    handleSubmit(name) {
      if(!this.info.AirTname && name == 'info') {
        this.$Message.error('请选择出货渠道')
        return
      }
      
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (name == "info") {

            if (this.info.Address > 0 || this.info.Ztd > 0) {
              this.Showdetailed = true;
            } else {

              this.$Message.error("請選擇您的地址!");
            }
            // this.addOrder();
          }
          if (name == "formRef") {
            this.upDateBag();
          }
          // if(name='formset'){
          //   this.setbag()
          // }
        } else {
          this.$Message.error("請將內容填寫完整!");
        }
      });
    },
    handleTaobao() {
      this.showTaobaoCode = false;
      this.$router.push(`./myOrder`);
    },
    handleZfb() {
      this.isShowZfb = false;
      this.isShowwx = false;
      this.isShowKZ = false;
      this.$router.push(`./myOrder`);
    },
    copy() {
      this.$Message.success("成功複製");
    },
    toLink() {
      this.$router.push(`./myOrder`);
      const TaoBaoUrl = localStorage.getItem("TaoBaoUrl");
      window.open(TaoBaoUrl);
      // window.open("https://shop375613435.taobao.com/");
    },
    changeSech() {
      if (this.search == "") {
        this.queryBillCode();
      }
    },
  },
  mounted() {
    this.queryBillCode(this.tabIndex);
    this.queryGoods();
    this.$nextTick(() => {
      this.$refs.scroll.refrushTable();
    })
  },
};
</script>
<style lang="scss" scoped>
.game {
  position: relative;
  display: flex;
  flex-direction: row;
  display: inline-block;
  top: 35px;
  left: 727px;
  height: 20px;
  z-index: 1;

  .background {
    width: 63px;
    height: 31px;
    background: #ff6666;
    position: absolute;
    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;
    left: 237px;
    top: 1px;

    img {
      margin: 5px 19px;
      cursor: pointer;
    }
  }

  .ivu-select-single .ivu-select-selection {
    border: 0px solid #fff;
  }
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

.ivu-table-cell-with-selection .ivu-checkbox-wrapper {
  margin-right: 18px;
}

/deep/ .ivu-checkbox-inner {
  width: 25px !important;
  height: 25px !important;
}

/deep/ .ivu-checkbox-input {
  opacity: 1;
}

/deep/ #table {
  .ivu-table-overflowX {
    overflow-x: hidden !important;
  }
  .ivu-table-fixed-right {
    right: 0;
    //  z-index: 99;
    width: 170px !important;
  }
}

.one {
  width: 100% !important;

  /deep/ .modal-content {
    width: 30% !important;
    height: 53vh;
  }

  .tip02 {
    font-size: 16px;
    margin: 6px 0 0 0;
  }
}

/deep/ .ivu-table table {
  font-size: 14px;
}

/deep/ .ivu-form .ivu-form-item-label {
  font-size: 14px;
  padding: 10px 6px 10px 0px;
}

/deep/.ivu-tabs {
  margin: 10px 0 0 0;
}

.stauts-top {
  display: flex;
  margin: 22px 0 0 0;
  flex-direction: row;
  justify-content: flex-end;
  line-height: 40px;
  height: 40px;
  font-size: 18px;

  .apply-btn {
    width: 180px;
    margin-left: 20px;
  }
}

.bagImg {
  width: 100%;
}

.wuliu {
  width: 600px;
  height: 600px;
  margin: 0 auto;
}

.link-box {
  padding: 20px;

  .linktaobao {
    color: #f00;
    text-decoration: underline;
    text-align: center;
    margin-top: 30px;
    cursor: pointer;
  }

  div {
    line-height: 40px;
    font-size: 28px;
  }

  p {
    line-height: 40px;
    font-size: 28px;
  }
}

.info-flex {
  display: flex;
  margin-top: 10px;
  position: relative;
}

.select-flex {
  display: flex;
  margin-bottom: 20px;

  .label {
    width: 82px;
    line-height: 32px;
  }

  .select-style {
    margin-right: 10px;
    display: flex;
  }
}

.myBag-wrapper {
  background: #fff;
  border-radius: 6px;
  padding: 20px;
  min-height: 750px;

  .myBag-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .modal-bag {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    overflow: auto;

    .modal-content {
      z-index: 999;
      display: block;
      width: 500px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      display: flex;
      flex-direction: column;

      .frame_title {
        padding: 20px 0;
        margin: 0 30px;
        border-bottom: 1px solid #ddd;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .ft_name {
          font-size: 20px;
          font-weight: bold;
          color: rgba(34, 34, 34, 1);
        }

        .close_btn {
          width: 23px;
          height: 23px;
          cursor: pointer;

          >img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .frame-container {
        padding: 10px 30px;
        flex: 1;
        overflow: auto;

        .upBtn {
          width: 30%;
          margin: 0 auto;
        }
      }
    }
  }
}

.pirce-wrapper {
  font-size: 20px;
  color: #333;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .price {
    color: #f00;
  }
}

.price-title {
  font-size: 20px;
  color: #333;

  .price {
    color: #f00;
  }
}

.list-left {
  display: flex;
}

.row-left {
  width: 220px;
  color: #666;
  font-size: 12px;

  >span {
    color: #ccc;
  }
}

.info-form {
  width: 100%;
  margin: 0 auto;
  margin-top: 20px;

  .tip-box {
    position: relative;

    .tips {
      color: #f00;
      position: absolute;
      bottom: -30px;
      left: 0;
      width: 260px;
    }
  }

  .btn-info {
    width: 500px;
    height: 46px;
    margin: 30px 0 0 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/view/homeManage/myBag.vue